ReactPaginate = require 'react-paginate'
{ NavLink } = require 'react-router-dom'

styles = require 'components/shared/styles/list'
stylesList = require 'components/shared/styles/list-item'
paginationStyles = require 'components/shared/styles/pagination.styl'
stylesLoader = require 'components/shared/styles/loader.styl'
LoadableWrapperComponent = require 'components/shared/LoadableWrapperComponent/LoadableWrapperComponent'

class LandingsListComponent extends React.Component
  render: ->
    { loading, error, landings, pagesCount, paginateClickHandler } = @props
    React.createElement("div", {"className": (styles.container)},
      React.createElement(LoadableWrapperComponent, {"loading": (loading)},
        (if error
          React.createElement("div", {"className": (styles.error)}, """
            Can\'t connect to the server
""")
        else
          if landings.length > 0
            landings.map (landing) ->
              React.createElement(NavLink, { \
                "to": ("/landings/#{landing.id}"),  \
                "key": (landing.id),  \
                "className": ( stylesList.container ),  \
                "activeClassName": ( stylesList.selected )
              },
                (landing.name)
              )
          else
            React.createElement("div", {"className": (styles.no_results)}, """
              You don\'t have any landings
""")
        )
      ),
      (
        if pagesCount > 1
          breakLabel = React.createElement("a", {"className": (paginationStyles.pageLink), "href": ''}, "...")
          React.createElement("div", {"className": (paginationStyles.wrapper)},
            React.createElement(ReactPaginate.default, { \
              "pageCount": (pagesCount),  \
              "marginPagesDisplayed": (2),  \
              "pageRangeDisplayed": (4),  \
              "breakLabel": (breakLabel),  \
              "breakClassName": (paginationStyles.page),  \
              "onPageChange": (paginateClickHandler),  \
              "pageClassName": (paginationStyles.page),  \
              "nextClassName": (paginationStyles.page),  \
              "previousClassName": (paginationStyles.page),  \
              "activeClassName": (paginationStyles.active),  \
              "pageLinkClassName": (paginationStyles.link),  \
              "nextLinkClassName": (paginationStyles.link),  \
              "previousLinkClassName": (paginationStyles.link),  \
              "containerClassName": (paginationStyles.container)
            })
          )
      )
    )

module.exports = LandingsListComponent
